import { render, staticRenderFns } from "./DialogOpenScan.vue?vue&type=template&id=be964e86&scoped=true&"
import script from "./DialogOpenScan.ts?vue&type=script&lang=ts&"
export * from "./DialogOpenScan.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be964e86",
  null
  
)

export default component.exports
import {QList,QItem,QBtn,QSeparator,QSpinnerAudio,ClosePopup} from 'quasar'
component.options.components = Object.assign({QList,QItem,QBtn,QSeparator,QSpinnerAudio}, component.options.components || {})
component.options.directives = Object.assign({ClosePopup}, component.options.directives || {})
